import { Module } from 'vuex';
import { RootState } from '@/store/rootState';
import { RunsState } from '@/store/modules/runs/runsState';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import state from './state';

const runs: Module<RunsState, RootState> = {
    namespaced: true,
    mutations,
    actions,
    state,
    getters,
};

export default runs;
